<template>
    <div>
        <design2021-apprentice-data-table
            class="studentTable"
            :items="tableData"
            :fields="studentFields"
            show-empty>
            <template v-slot:cell(motivation)="data">
                <b-button
                    class="btn-clipboard remove-icon-margin"
                    v-if="data.item.motivation !== null"
                    v-b-tooltip:hover
                    variant="primary-icon-only"
                    :title="$t('internship.view_motivation')"
                    @click="openMotivationModal(data.item.motivation)">
                </b-button>
            </template>
            <template v-slot:cell(action)="data">
                <div class="actions">
                    <b-button
                        class="btn-sign-in btn-module-sign-in remove-icon-margin"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('common.confirm')"
                        @click="acceptStudent(data.item.id)">
                    </b-button>
                    <b-button
                        class="btn-sign-out btn-module-sign-out remove-icon-margin"
                        v-b-tooltip.hover
                        variant="danger-icon-only"
                        :title="$t('internship.reject')"
                        @click="openRejectionModal(data.item.id)">
                    </b-button>
                </div>
            </template>

            <template #empty="scope">
                <div class="not-found with-header empty-student-list">
                    <div class="icon">
                        <i
                            class="fas fa-exclamation-circle"
                            data-v-e13f5460=""></i>
                    </div>
                    <div class="alert-notice">{{ $t('internship.no_registrations_found') }}</div>
                </div>
            </template>
        </design2021-apprentice-data-table>

        <design-2021-internship-edit-applying-students-tab-rejection-modal-component
            @reject="reject($event)"
            ref="reject-student-modal"
            :internship-in="this.internship">
        </design-2021-internship-edit-applying-students-tab-rejection-modal-component>
        <design-2021-internship-edit-students-tab-motivation-modal-component ref="motivation-modal">
        </design-2021-internship-edit-students-tab-motivation-modal-component>
    </div>
</template>

<script>
import Design2021ApprenticeDataTable from '../../../common/design-2021-apprentice-data-table';

export default {
    name: 'design-2021-internships-edit-applying-students-tab-component',
    components: { Design2021ApprenticeDataTable },
    props: ['internshipIn', 'applyingStudentsIn', 'allStudentsLoadedIn'],
    data() {
        return {
            internship: this.internshipIn,
            students: this.applyingStudentsIn,
            studentFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'email',
                    label: this.$t('common.email_address'),
                },
                {
                    key: 'motivation',
                    label: this.$t('internship.motivation'),
                },
                {
                    key: 'action',
                    label: this.$t('internship.motivation'),
                },
            ],
        };
    },
    computed: {
        tableData() {
            return this.applyingStudentsIn.map((student) => {
                return {
                    id: student.id,
                    name: student.full_name,
                    email: student.email,
                    motivation: student.pivot.motivation,
                };
            });
        },
    },
    methods: {
        reject(userId) {
            this.$emit('reject', userId);
        },
        acceptStudent(userId) {
            this.axios
                .post(this.routes.internshipAcceptStudent(), {
                    userId: userId,
                    internshipId: this.internship.id,
                })
                .then(
                    (response) => {
                        this.$emit('studentAccepted', userId);
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
        },
        openRejectionModal(userId) {
            this.$refs['reject-student-modal'].show(userId);
        },
        openMotivationModal(motivation) {
            this.$refs['motivation-modal'].show(motivation);
        },
    },
};
</script>

<style scoped lang="scss">
.actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    column-gap: map-get($grid-gutter-spacing, 'fifteen');

    button {
        &:before {
            margin: 0;
        }
    }
}
</style>
